<template>
  <div class="title-with-lines">
    <div
      class="title-with-lines__title"
      v-html="title"
    />
    <Lines class="title-with-lines__lines" />
  </div>
</template>

<script>
  import Lines from '@/assets/svg/lines.svg'
  export default {
    name: 'TitleWithLines',

    components: {
      Lines
    },

    props: {
      title: {
        type: String,
        default: ''
      }
    }
  }
</script>

<style lang="scss">
.title-with-lines {
  position: relative;
  padding-left: 114px;

  @include mobile {
    padding-left: 16px;
    padding-right: 100px;
  }

  &__title,
  p {
    position: relative;
    width: 100%;
    max-width: 552px;
    font-size: 54px;
    font-weight: 700;
    line-height: 1.18;
    text-transform: uppercase;
    color: $c-black;
    z-index: 1;

    @include tablet {
      font-size: 50px;
    }

    @include mobile {
      font-size: 24px;
    }

    span {
      color: $c-red;
    }
  }

  &__lines {
    position: absolute;
    top: 50%;
    left: 0;
    width: 100%;
    height: 16px;
    transform: translateY(-50%);
    z-index: 0;

    @include mobile {
      height: 10px;

      rect {
        &:nth-child(2) {
          y: 4;
        }

        &:nth-child(3) {
          y: 8;
        }
      }
    }
  }
}
</style>
